import isNil from 'lodash/isNil';
import upperFirst from 'lodash/upperFirst';
import moment from 'moment';
import { DateIcon } from 'tombac-icons';
import { LimitSummaryContainer, LimitSummaryIcon, LimitSummaryLimit } from "./limitSummaryElements";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DateRangeLimitSummary({
  className,
  limit,
  schema,
  variant = 'summary'
}) {
  return !isNil(limit) && (limit.from || limit.to) ? /*#__PURE__*/_jsxs(LimitSummaryContainer, {
    className: className,
    schema: schema,
    children: [variant === 'summary' && /*#__PURE__*/_jsx(LimitSummaryIcon, {
      as: DateIcon
    }), ' ', /*#__PURE__*/_jsx(LimitSummaryLimit, {
      children: upperFirst(`${limit.from ? 'from ' + moment(limit.from).format('DD/MM/YYYY') : ''} ${limit.to ? 'to ' + moment(limit.to).format('DD/MM/YYYY') : ''}`.trim())
    })]
  }) : variant === 'basic' ? /*#__PURE__*/_jsx(LimitSummaryContainer, {
    className: className,
    schema: schema,
    children: "Unlimited"
  }) : null;
}